import React from "react";
import ReactApexChart from "react-apexcharts";
import { fontFamilies } from "theme/fontConfig";

const ProfileCompletion = ({ title, profile, handleClick }) => {
  var radialChart = {
    series: [profile],
    options: {
      // ApexCharts uses Helvetica by default; use the app font
      chart: { fontFamily: fontFamilies.primary },
      plotOptions: {
        radialBar: {
          offsetX: -20,
          track: {
            background: "rgba(36, 85, 239,0.1)",
          },
          dataLabels: {
            showOn: "always",
            value: {
              offsetY: -10,
              fontSize: "15px",
              fontFamily: fontFamilies.primary,
              color: "#464E5F",
              fontWeight: "bold",
            },
          },
        },
      },
      fill: {
        type: "color",
        colors: ["#2555EF"],
      },
      stroke: {
        lineCap: "round",
      },
      labels: [""],
    },
  };

  return (
    <div className="profile-completion" onClick={handleClick}>
      <div className="d-flex align-items-center">
        <div className="">
          <ReactApexChart
            options={radialChart.options}
            series={radialChart.series}
            type="radialBar"
            width={90}
          />
        </div>
        <div className="profile-completion-text">
          <div className="p-h">{title ? title : "Profile"} completion</div>
          <div className="p-t">Complete profile details</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletion;
